var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogocellsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 131,
    viewBox: "0 0 187 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.4 64.6C82.1333 65.6667 81.8667 67.1333 81.6 69L3 60.6H83L82.4 64.6ZM80.2 79.8C79.8 82.8667 79.6 85.6667 79.6 88.2L0.799999 79.8H80.2ZM87.8 41.4L85.4 49.6L7.8 41.4H87.8ZM79.8 99C80.3333 102.733 80.8 105.533 81.2 107.4L3.4 99H79.8ZM96 22.2C94.1333 25.6667 92.8 28.3333 92 30.2L17.2 22.2H96ZM85.8 118.4C87.5333 121.467 89.5333 123.933 91.8 125.8L22.6 118.4H85.8ZM115 3C111.133 5.39999 108.133 7.59999 106 9.6L44.8 3H115ZM132.6 131C115.8 131 103.733 127.733 96.4 121.2C89.2 114.667 85.6 104.6 85.6 91C85.6 85.2667 86.5333 76.8 88.4 65.6C92.4 42.6667 99.2667 26 109 15.6C118.867 5.19999 134.4 -9.05991e-06 155.6 -9.05991e-06C160.533 -9.05991e-06 166.133 0.533325 172.4 1.59999C178.8 2.53333 183.467 3.73333 186.4 5.2L175.2 35.8C167.333 33.9333 159.933 33 153 33C146.2 33 141.333 33.6667 138.4 35C135.467 36.3333 133.667 39 133 43L123.8 95.4C128.6 96.4667 133.533 97 138.6 97C149.4 97 159.267 95.4 168.2 92.2L165 125.8C156.467 129.267 145.667 131 132.6 131Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocellsite);
export default __webpack_public_path__ + "static/media/logocellsite.93fa1d10223154049f22b9b3bc3271a0.svg";
export { ForwardRef as ReactComponent };